const config = {
    firebase: {
        apiKey: "AIzaSyBHZbS402KgkrH4T6KuqYBqvg-aVS1Exvs",
        authDomain: "testing-auth-befe3.firebaseapp.com",
        projectId: "testing-auth-befe3",
        storageBucket: "testing-auth-befe3.appspot.com",
        messagingSenderId: "299445323805",
        appId: "1:299445323805:web:cf4cf1180f494c57521ef4"
    }
}

export default config;
